import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";

import ApiRequestErrorHandler from "../../../../../global/ApiRequestErrorHandler";
import ResponseModal from "../../../../../global/ResponseModal";

import CaseHealthList from "./components/CaseHealthList";

export default function CaseHealth() {
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [errorArray, setErrorArray] = useState([]);
  const { caseHealth } = useLoaderData();

  const handleApiError = (error) => {
    const res = error.response.data;
    const errArr = ApiRequestErrorHandler(res);
    setErrorArray(errArr);
    setOpenError(!openError);
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        setIssues(caseHealth);
      } catch (err) {
        handleApiError(err);
      }
    };
    fetchData();
    setLoading(false);
  }, [caseHealth]);

  return (
    <div>
      <div>
        {loading ? (
          <div className="flex h-40 w-full items-center justify-center">
            <CircularProgress color="secondary" />
          </div>
        ) : (
          <>
            {issues.length === 0 ? <div>No data to display</div> : <CaseHealthList data={issues} />}
          </>
        )}
      </div>
      <ResponseModal
        title="Failure"
        isError={true}
        openBool={openError}
        setOpenBool={setOpenError}
        errorMessage={errorArray}
      />
    </div>
  );
}
